var React = require('react');

function NavNorhartLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M125 550V375c0-96.002 78.998-175 175-175s175 78.998 175 175v175M1000 375c0 96.002-78.998 175-175 175s-175-78.998-175-175 78.998-175 175-175 175 78.998 175 175M1175 550V350c0-82.288 67.71-150 150-150M1500 550V125M1500 350c0-82.288 67.71-150 150-150s150 67.712 150 150v200M2325 375c0 96.002-79 175-175 175s-175-78.998-175-175 79-175 175-175 175 78.998 175 175v175M2500 550V350c0-82.288 67.71-150 150-150M2825 125v275c0 82.288 67.71 150 150 150M2825 225h150","style":{"fill":"none","fillRule":"nonzero","stroke":"#fff","strokeWidth":"100px"},"transform":"matrix(.033 0 0 .033 -1.289 -1.893)"}));
}

NavNorhartLogo.defaultProps = {"width":"120","height":"20","viewBox":"0 0 100 20","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinecap":"round"}};

module.exports = NavNorhartLogo;

NavNorhartLogo.default = NavNorhartLogo;
